enum Actions {
  // action types
  ADD_BODY_CLASSNAME = "addBodyClassName",
  REMOVE_BODY_CLASSNAME = "removeBodyClassName",
  ADD_BODY_ATTRIBUTE = "addBodyAttribute",
  REMOVE_BODY_ATTRIBUTE = "removeBodyAttribute",
  ADD_CLASSNAME = "addClassName",
  VERIFY_AUTH = "verifyAuth",
  LOGIN = "login",
  LOGOUT = "logout",
  REGISTER = "register",
  UPDATE_USER = "updateUser",
  FORGOT_PASSWORD = "forgotPassword",
  SET_BREADCRUMB_ACTION = "setBreadcrumbAction",
  SET_THEME_MODE_ACTION = "setThemeModeAction",
  CONFIRM_EMAIL = "confirmEmail",
  RESEND_CONFIRMATION_EMAIL = "resendConfirmationEmail",
  RESET_PASSWORD = "resetPassword",
  GET_RESIDENT_RELATIONSHIP_PRIORITY = "getResidentRelationshipPriority",
  GET_LONG_TERM_CARE_HOMES = "getLongTermCareHomes",
  GET_RESIDENTS_APPLICATIONS = "getResidentsApplications",
  GET_RESIDENT_APPLICATION_BY_ID = "getResidentApplicationById",
  GET_RESIDENT_SEXES = "getResidentSexes",
  GET_RESIDENT_CURATOR_TYPES = "getResidentCuratorTypes",
  GET_RESIDENT_TUTOR_TYPES = "getResidentTutorTypes",
  GET_RESIDENT_FILE_TYPES = "getResidentFileTypes",
  SUBMIT_RESIDENT_APPLICATION = "submitResidentApplication",
  GET_MY_RESIDENT_APPLICATION = "getMyResidentApplication",
  GET_RESIDENT_APPLICATION_PROFILE_SUMMARY = "getResidentApplicationProfileSummary",
  SAVE_RESIDENT_INFORMATION = "saveResidentInformation",
  SAVE_PRINCIPAL_RESPONDENT_INFORMATION = "savePrincipalRespondentInformation",
  SAVE_RESIDENT_PERSONAL_INFORMATION = "saveResidentPersonalInformation",
  SAVE_RESIDENT_SOCIAL_DATA = "saveResidentSocialData",
  SAVE_MATERIAL_POSSESSION_RESPONDENT_INFORMATION = "saveMaterialPossessionRespondentInformation",
  SAVE_CAREGIVER_RESPONDENT_INFORMATION = "saveCaregiverRespondentInformation",
  SAVE_SIGNIFICANT_PERSON_INFORMATION = "saveSignificantPersonInformation",
  SAVE_FUNERAL_ARRANGEMENTS = "saveFuneralArrangements",
  SAVE_BILLING_INFORMATION = "saveBillingInformation",
  SAVE_PICTURE_AUTHORIZATION = "savePictureAuthorization",
  SAVE_PAYMENT_INFORMATION = "savePaymentInformation",
  APPROVE_RESIDENT_APPLICATION = "approveResidentApplication",
  REJECT_RESIDENT_APPLICATION = "rejectResidentApplication",
  DOWNLOAD_PROXY_FILE = "downloadProxyFile",
  DOWNLOAD_MANDATE_FILE = "downloadMandateFile",
  DOWNLOAD_VOID_CHEQUE = "downloadVoidCheque",
  APPROVE_VOID_CHEQUE = "approveVoidCheque",
  REJECT_VOID_CHEQUE = "rejectVoidCheque",
  DELETE_VOID_CHEQUE = "deleteVoidCheque",
  DOWNLOAD_PDF_FORMS = "downloadPdfForms",
  GET_MY_ADMINISTRATIVE_FORMS = "getMyAdministrativeForms",
  SAVE_GOODS_MANAGEMENT_POLICY = "saveGoodsManagementPolicy",
  SAVE_CHSLD_CONSENT = "saveChsldConsent",
  SAVE_DIGITAL_CONTENT_CONSENT = "saveDigitalContentConsent",
  SAVE_CLOTHES_CLEANING_SELECTION = "saveClothesCleaningSelection",
  SAVE_TELECOM_UTILITIES_SELECTION = "saveTelecomUtilitiesSelection",
  SAVE_HAIR_SALON_SELECTION = "saveHairSalonSelection",
  SAVE_MANICURE_AND_PEDICURE_SELECTION = "saveManicureAndPedicureSelection",
  SAVE_PAID_ACTIVITY_SELECTION = "savePaidActivitySelection",
  GET_HAIR_SALON_SERVICE_FREQUENCY = "getHairSalonServiceFrequency",
  GET_MANICURE_AND_PEDICURE_SERVICE_FREQUENCY = "getManicureAndPedicureServiceFrequency",
  GET_ADMINISTRATIVE_FORM_BY_ID = "getAdministrativeFormById",
  GET_RESIDENT_BY_ID = "getResidentById",
  UPDATE_RESIDENT = "updateResident",
  SIGN_CHSLD_CONSENT = "signChsldConsent",
  SIGN_DIGITAL_CONTENT_CONSENT = "signDigitalContentConsent",
  SIGN_PAID_ACTIVITY_SELECTION = "signPaidActivitySelection",
  GET_DOCUMENTS = "getDocuments",
  UPLOAD_DOCUMENT = "uploadDocument",
  REFRESH_TOKEN = "refreshToken",
  VERIFY_TWO_FACTOR = "verifyTwoFactor",
  SETUP_AUTHENTICATOR = "setupAuthenticator",
  VERIFY_AUTHENTICATOR_SETUP = "verifyAuthenticatorSetup",
}

enum Mutations {
  // mutation types
  SET_CLASSNAME_BY_POSITION = "appendBreadcrumb",
  PURGE_AUTH = "logOut",
  SET_AUTH = "setAuth",
  SET_USER = "setUser",
  SET_PASSWORD = "setPassword",
  SET_ERROR = "setError",
  SET_TWO_FACTOR = "setTwoFactor",
  CLEAR_TWO_FACTOR = "clearTwoFactor",
  SET_BREADCRUMB_MUTATION = "setBreadcrumbMutation",
  SET_LAYOUT_CONFIG_PROPERTY = "setLayoutConfigProperty",
  RESET_LAYOUT_CONFIG = "resetLayoutConfig",
  OVERRIDE_LAYOUT_CONFIG = "overrideLayoutConfig",
  OVERRIDE_PAGE_LAYOUT_CONFIG = "overridePageLayoutConfig",
  SET_THEME_MODE_MUTATION = "setThemeModeMutation",
  SET_MY_RESIDENT_APPLICATION = "setMyResidentApplication",
}

export { Actions, Mutations };
